import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

const searchSchema = z.object({
  tab: z
    .enum(['profile', 'team', 'security', 'preferences'])
    .optional()
    .catch('profile'),
});

export const Route = createFileRoute('/_protected/dashboard/settings')({
  validateSearch: searchSchema,
});
